import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FilePreviewComponent } from '../../file-preview/file-preview.component';
import { FilePreviewService } from '../../file-preview/file-preview.service';
import { MessagePack } from '../../model';

@Component({
  selector: 'app-file-element',
  templateUrl: './file-element.component.html',
  styleUrls: ['./file-element.component.less']
})
export class FileElementComponent implements OnInit {

  @Input() message: MessagePack = null;
  constructor(public filePreview: FilePreviewService) { }

  ngOnInit(): void {

  } 


  onClick() {
    let m = this.message;
    this.filePreview.filePreview(m.MediaUrl, m.Data.FileName, m.Data.Extension);
  }


}
